import wx from 'weixin-js-sdk'
import Vue from "vue";
/***************正式161**********************/
var wxkey='wx5fb97993ea2ae9ca';

/***************测试227**********************/
// var wxkey='wx92da1f7ae518b7ed';
export default {
  gettime:function (time) {
    var itemdata=new Date(time.replace(new RegExp("-", "gm"), "/"));
    var y = itemdata.getFullYear();
    var m = itemdata.getMonth()+1;
    var d = itemdata.getDate();
    var h = itemdata.getHours();
    var mm =itemdata.getMinutes();
    var s = itemdata.getSeconds();
    return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
  },
  add0:function (m) {
    return m<10?'0'+m:m
  },
  fenxiang:function (title,desc,type,img,param,callback) {
   if(localStorage.getItem(Vue.prototype.wxToken+'_meberid')==''
     && localStorage.getItem(Vue.prototype.wxToken+'_meberid')==null){
     $.ajax({
       url:"/api/consumer-member/wx/member/info/getMemberByToken",
       type:'post',
       data:{
         wxToken:res.result,
         talk:'talk'
       },
       async: false,
       success:function (res) {
         if(res.code=='10000'){
           localStorage.setItem(res.result+'_meberid',res.result.id);
           localStorage.setItem(res.result+'_headImg',res.result.headImg);
           localStorage.setItem(res.result+'_smallname',res.result.memberName);
         }
       }
     })
   }
    var that=this;
    var wxtitle="问壹声";
    var wxdesc="wx";
    var wximg =Vue.prototype.path+'/images/logo.png';

    var wxparam='';
    if(title){
      wxtitle=decodeURIComponent(title);
    }
    if(desc){
      wxdesc=decodeURIComponent(desc);
    }
    if (typeof img == 'string') {
      if(img.substring(0,4) == 'http'){
        wximg = img;
      } else {
        wximg = Vue.prototype.img_url + img;
      }
    }

    if(param){
      wxparam=param;
    }
    // console.log(url);
    var wxlink=Vue.prototype.fenxiangurl + 'consumer-member/srrjShareRecord/share?meberId='+
      localStorage.getItem(Vue.prototype.wxToken+'_meberid')+'&type='+type+'&param='+wxparam;
    // var wxlink = window.location.href();
    wx.ready(function () {
      wx.hideMenuItems({
        menuList: ["menuItem:copyUrl"] // 要显示的菜单项，所有menu项见附录3
      });
      wx.onMenuShareAppMessage({
        title: wxtitle, // 分享标题
        desc: wxdesc, // 分享描述
        link: wxlink, // 分享链接
        imgUrl: wximg, // 分享图标
        success: function (res) {
          that.savefenxiang(wxtitle,wximg,wxdesc);
        },
        cancel: function (res) {
          console.log(res)
          //   alert('已取消'); // 用户取消分享后执行的回调函数
        },
        fail: function (res) {
          console.log(res)
        }
      });
      if (that.checkAgent() == 'ios') {
        wx.onMenuShareTimeline({
          title: wxtitle,
          link: wxlink, // 分享链接
          imgUrl: wximg, // 分享图标
          success: function () {
          },
          complete: function () {

          },
          trigger: function () {
            that.savefenxiang(wxtitle,wximg,wxdesc);

          }
        });
      } else {
        wx.onMenuShareTimeline({
          title: wxtitle,
          link: wxlink, // 分享链接
          imgUrl: wximg, // 分享图标
          success: function () {
            that.savefenxiang(wxtitle,wximg,wxdesc);
          },
          complete: function () {
          }
        });
      }

      wx.onMenuShareQQ({
        title: wxtitle, // 分享标题
        desc: wxdesc, // 分享描述
        link: wxlink,// 分享链接
        imgUrl: wximg, // 分享图标
        success: function () {
          that.savefenxiang(wxtitle,wximg,wxdesc);
        },
        cancel: function () {
        }
      });

      wx.onMenuShareWeibo({
        title: wxtitle, // 分享标题
        link: wxlink,// 分享链接
        imgUrl: wximg, // 分享图标
        success: function () {
          that.savefenxiang(wxtitle,wximg,wxdesc);
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          layer.msg("分享失败")
          // 用户取消分享后执行的回调函数
        }
      });

      wx.onMenuShareQZone({
        title: wxtitle, // 分享标题
        desc: wxdesc, // 分享描述
        link: wxlink,// 分享链接
        imgUrl:wximg, // 分享图标
        success: function () {
          that.savefenxiang(wxtitle,wximg,wxdesc);
          // 用户确认分享后执行的回调函数
        },
        cancel: function () {
          layer.msg("分享失败")
          // 用户取消分享后执行的回调函数
        }
      });

    });
    wx.error(function (res) {
      console.log(res)
    });

  },
  savefenxiang:function (wxtitle,wximg,wxdesc) {
    var id = sessionStorage.getItem('articleid')
    $.ajax({
      url:'/api/consumer-member/srrjShareRecord/saveRecord',
      data:{
        userType:0,
        shareTitle:wxtitle,
        shareImg:wximg,
        shareContent:wxdesc,
        id: id
      },
      type:'post',
      success:function (res) {
      }
    })
  },
  setjurisdiction:function () {
    // alert(window.location.href)
    $.ajax({
      url:'/api/consumer-member/srrjShareRecord/getSignature',
      type:'get',
      data:{
        url:encodeURIComponent(window.location.href),
        wxToken:localStorage.getItem('ACCESS_TOKE')
      },
      async:false,
      success:function (res) {
        if(res.code=='10000'){
          // alert(JSON.stringify(res.result))
          wx.config({
            debug: false,
            appId: res.result.appid,
            timestamp:  res.result.timestamp,
            nonceStr: res.result.noncestr,
            signature:res.result.signature ,
            jsApiList: [
              'checkJsApi',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'chooseImage',
              'uploadImage',
              'getLocalImgData',
              'previewImage',
              'downloadImage',
              'hideMenuItems',
              'onMenuShareQQ',
              'onMenuShareWeibo',
              'onMenuShareQZone'
            ]
          });
        }
      }
    })
  },
  checkAgent:function() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
    return "ios"
  } else if (/(Android)/i.test(navigator.userAgent)) {   //判断Android
    //alert(navigator.userAgent);
    return "android"
  } else {  //pc
    return "pc"
  }
  },
  getQueryString: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }
}
var isflag = false;
var weixin = {
  config: {
    url: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +wxkey+ '&redirect_uri=' + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect',
    userInfo: localStorage.getItem('ACCESS_TOKE'),
  },
  getQueryString: function (name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },
  getUser: function (code) {
    if (!isflag && (localStorage.getItem('ACCESS_TOKE') != "" || localStorage.getItem('ACCESS_TOKE') != null
      || localStorage.getItem('ACCESS_TOKE') != undefined || localStorage.getItem('ACCESS_TOKE') != "null")) {
      isflag = true;
      $.ajax({
        type: 'POST',
        url: '/api/consumer-member/wx/member/info/handleCode',
        data: {
          code: code
        },
        dataType: 'json',
        async: false,
        success: function (res) {
          if (res.success) {
            localStorage.setItem('ACCESS_TOKE', res.result);
            var wxtoken= localStorage.getItem('ACCESS_TOKE');
            isflag = false;
            $.ajax({
              url:"/api/consumer-member/wx/member/info/getMemberByToken",
              type:'post',
              data:{
                wxToken:wxtoken,
                talk:'talk'
              },
              success:function (res) {
                if(res.code=='10000'){
                     localStorage.setItem(wxtoken+'_meberid',res.result.id);
                     localStorage.setItem(wxtoken+'_headImg',res.result.headImg);
                     localStorage.setItem(wxtoken+'_smallname',res.result.memberName);
                }
              }
            })
          }
        },
        error: function (json) {
          console.log(json);
        }
      })
    }
  },
  getUserInfo: function () {
    console.log(1);
    // //判断有没有获取过token，如果有直接拿本地的

    if (!!localStorage.getItem('ACCESS_TOKE') ) {
      var wxtoken= localStorage.getItem('ACCESS_TOKE');
      $.ajax({
        url:"/api/consumer-member/wx/member/info/getMemberByToken",
        type:'post',
        data:{
          wxToken:wxtoken,
          talk:'talk'
        },
        success:function (res) {
          if(res.code=='10000'){
            localStorage.setItem(wxtoken+'_meberid',res.result.id);
            localStorage.setItem(wxtoken+'_headImg',res.result.headImg);
            localStorage.setItem(wxtoken+'_smallname',res.result.memberName);
            return localStorage.getItem('ACCESS_TOKE');
          } else {
            localStorage.removeItem('ACCESS_TOKE');
            weixin.getUserInfo();
          }
        }
      })
    } else {
      if (weixin.getQueryString('code') != null) {
        weixin.getUser(weixin.getQueryString('code'));
        // localStorage.setItem('code',weixin.getQueryString('code'));
        return localStorage.getItem('ACCESS_TOKE');
      } else {
        window.location.href = weixin.config.url;
      }
    }
  }
};
// localStorage.setItem('ACCESS_TOKE', 'obCkH0hxHdTSCvqixF79zBnAKOjI')
if (weixin.getQueryString('miniwxtoken')) { // 小程序token
  sessionStorage.setItem('miniwxtoken', weixin.getQueryString('miniwxtoken'))
  localStorage.setItem('ACCESS_TOKE', weixin.getQueryString('miniwxtoken'));
  localStorage.setItem('pt', 'mini');
} else if (!sessionStorage.getItem('miniwxtoken')) {
  if (localStorage.getItem('pt')) localStorage.removeItem('pt');
}
weixin.getUserInfo();



// WEBPACK FOOTER //
// ./src/assets/js/config.js